import { motion } from "framer-motion";
import { JOURNEY } from "@/lib/data";

export default function Journey() {
  return (
    <section
      id="journey"
      data-testid="section-journey"
      className="py-14 sm:py-20 relative"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-2xl">
          <span className="text-[11px] uppercase tracking-[0.24em] text-[#2563EB] dark:text-[#06B6D4] font-semibold">
            The Learning Journey
          </span>
          <h2 className="font-display mt-4 text-4xl sm:text-5xl tracking-tighter font-semibold text-[#0F172A] dark:text-white text-balance">
            Your Learning Journey
          </h2>
          <p className="mt-5 text-slate-600 dark:text-slate-300">
            Five clear steps from picking your package to earning your first
            income — guided by mentors and a community that holds you accountable.
          </p>
        </div>

        <div className="mt-16 relative">
          <div
            aria-hidden
            className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-300 dark:via-white/20 to-transparent"
          />

          <motion.ol
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            variants={{
              hidden: {},
              show: { transition: { staggerChildren: 0.1 } },
            }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8"
          >
            {JOURNEY.map((j, i) => (
              <motion.li
                key={j.step}
                data-testid={`journey-step-${j.step}`}
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
                }}
                className="relative"
              >
                <div className="relative z-10 inline-flex h-12 w-12 items-center justify-center rounded-full border border-slate-300 dark:border-white/15 bg-white dark:bg-[#0F172A] font-display text-sm font-semibold tracking-tight text-[#0F172A] dark:text-white">
                  {j.step}
                  <span className="absolute -inset-1 rounded-full border border-[#06B6D4]/30 animate-pulse" />
                </div>
                <h3 className="mt-6 font-display text-xl font-medium tracking-tight text-[#0F172A] dark:text-white">
                  {j.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-400">
                  {j.desc}
                </p>
                {i < JOURNEY.length - 1 && (
                  <span className="lg:hidden block mt-6 h-8 w-px bg-slate-300 dark:bg-white/15 mx-6" />
                )}
              </motion.li>
            ))}
          </motion.ol>
        </div>
      </div>
    </section>
  );
}
